import SHAREBOX_I32_CHECK_OUT_STEPS from './i32';

const SHAREBOX_S32_PLUS_CHECK_OUT_STEPS = SHAREBOX_I32_CHECK_OUT_STEPS;

export default SHAREBOX_S32_PLUS_CHECK_OUT_STEPS;
